<template>
  <div class="pages" v-if="page_show">
    <div class="detail_box">
      <div class="detail_header">
        <div class="position_name2">{{ position.position_name }}</div>
        <div class="label_list2">
          <van-icon name="location-o" size="16px" />
          <span>{{ position.area }}</span>
          <van-icon name="apps-o" size="16px" />
          <span>{{ position.position_type }}</span>
          <van-icon name="friends-o" size="16px" />
          <span>{{ position.people_num }}</span>
        </div>
        <!-- <div class="publish_at2">{{ position.publish_at }}发布</div> -->
      </div>
    </div>
    <div class="block_title">基本信息</div>
    <van-form validate-first @failed="onFailed" @submit="onSubmit">
      <van-field v-model="realname" name="realname" label="姓名" placeholder="姓名"
        :rules="[{ required: true, message: '请输入姓名' }]" />
      <van-field v-model="mobile" name="mobile" tyle="tel" label="手机" placeholder="手机"
        :rules="[{ required: true, message: '请输入手机号码' }, { validator: mobileRule, message: '请输入正确的手机号码' }]" />
      <van-field v-model="email" name="email" label="邮箱" placeholder="邮箱"
        :rules="[{ required: true, message: '请输入邮箱' }, { validator: emailRule, message: '请输入正确的邮箱' }]" />
      <van-field name="uploader" label="简历上传">
        <template #input>
          <div style="display: flex; flex-direction: column;">
            <van-uploader v-model="uploader" name="upload_files" max-count="3" upload-icon="invitation" upload-text="点击上传"
              accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :before-read="beforeRead" :after-read="afterRead"
              :before-delete="beforeDelete" @click-preview="onPreview" />
            <span class="help_block">仅支持上传word、ppt、pdf格式，最多上传3份附件</span>
          </div>
        </template>
        <template #extra>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      position_id: null,
      page_show: false,
      position: null,
      posting: false,
      realname: '',
      mobile: '',
      email: '',
      uploader: [],
      upload_files: []
    }
  },
  mounted() {
    document.title = '中船航海人才招聘'
    this.position_id = this.$route.query.position_id
    this.loadData()
  },
  methods: {
    loadData() {
      let that = this
      that.$api.employPositionDetail({
        position_id: that.position_id,
      }).then(res => {
        that.page_show = true
        that.position = res.data.record
      })
    },
    mobileRule(val) {
      return /^1\d{10}$/.test(val);
    },
    emailRule(val) {
      return /^(.*)@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val);
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onSubmit(formData) {
      let that = this
      Dialog.confirm({
        title: '提示',
        message: '是否确认申请该岗位？',
      }).then(() => {
        if (that.posting) {
          return false
        }
        that.posting = true
        formData['position_id'] = that.position_id
        formData['upload_ids'] = new Array()
        formData.uploader.forEach(element => {
          formData['upload_ids'].push(element.upload_id)
        })
        delete formData.uploader
        console.log('onSubmit', formData);
        that.$api.employPositionPost(formData).then(res => {
          that.posting = false
          Toast.success(res.msg)
        }).catch(res => {
          that.posting = false
          Toast.fail(res.data.msg)
        })
      })
    },
    beforeRead(file, detail) {
      return true;
    },
    afterRead(file, detail) {	//文件读取完成后的回调函数
      let that = this
      this.Util.uploadFile(file.file, 'employ').then(res => {
        that.uploader[detail.index].upload_id = res.data.record_item['upload_id']
      }).catch(res => {
        if (res.data && res.data.msg) {
          Toast.fail(res.data && (res.data.msg))
        } else {
          Toast.fail('系统异常')
        }
      })
    },
    beforeDelete(file, detail) {
      this.uploader.splice(detail.index, 1)
    },
    onPreview(e) {
      console.log(e)
    }
  }
}
</script>
<style scoped src="./positionPost.css"></style>